import React from 'react'
import SvgIcon from '../SvgIcon'

export default function ClosedEyeIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 15 15">
      <path d="M7.5 8.8a1.3 1.3 0 0 1-.919-.381l1.838-1.838A1.3 1.3 0 0 1 7.5 8.8M14.57.57l-.141-.141a.5.5 0 0 0-.707.001L8.786 5.366a2.455 2.455 0 0 0-1.774-.317 2.517 2.517 0 0 0-1.963 1.963c-.132.659.013 1.27.317 1.774L.429 13.722a.5.5 0 0 0 .001.708l.141.141a.5.5 0 0 0 .707-.001l4.936-4.936a2.455 2.455 0 0 0 1.774.317 2.517 2.517 0 0 0 1.963-1.963 2.455 2.455 0 0 0-.317-1.774l4.937-4.936A.5.5 0 0 0 14.57.57M7.5 13c-.818 0-1.634-.187-2.434-.52l.924-.925a5.032 5.032 0 0 0 1.51.245c2.228 0 4.379-1.521 6.106-4.3a12.71 12.71 0 0 0-1.542-2.018l.84-.84a14.04 14.04 0 0 1 1.784 2.33c.197.32.205.724.009 1.044C12.668 11.339 10.084 13 7.5 13m0-11c.818 0 1.634.187 2.434.52l-.924.925A5.032 5.032 0 0 0 7.5 3.2c-2.228 0-4.379 1.521-6.106 4.3a12.71 12.71 0 0 0 1.542 2.018l-.84.84a14.04 14.04 0 0 1-1.784-2.33.998.998 0 0 1-.009-1.044C2.332 3.661 4.916 2 7.5 2M0 0v15m15 0V0" />
    </SvgIcon>
  )
}

ClosedEyeIcon.displayName = 'ClosedEyeIcon'
